import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { FC } from 'react';

import FullScreenModal from '../../../components/Modal/FullScreenModal/FullScreenModal';
import { InfoTooltip } from '../../documents/components/infoTooltip/InfoTooltip';
import { useBankInstitutionsSelector } from './BankInstitutionsSelector.hooks';
import { BankInstitutionPaper, ButtonBox, FormTitleTypography, HeaderGrid, ImageBox, MainStyledContainer, ScrollingStyledContainer, SearchBarInput, SearchInputAdornment, SearchTitleTypography } from './BankInstitutionsSelector.styles';

type bankInstitutionsSelectorProp = {
    onOk: (institutionId: string, importStartDate: Date) => void,
    onCancel: () => void
}

export const BankInstitutionsSelector: FC<bankInstitutionsSelectorProp> = ({ onOk, onCancel }) => {

    const {
        searchText, handleOnSearchChange,
        filteredBankInstitutions,
        selectedDate, setSelectedDate,
        handleSelectionModel,
        selectedBankInstitution,
        handleSave,
        isValidImportDate,
        isValidForm
    } = useBankInstitutionsSelector(onOk);


    function getModelBodyJsx() {
        return (
            <MainStyledContainer>
                <HeaderGrid container>
                    <Grid item xs={12} alignContent="flex-start">
                        <FormTitleTypography variant='formTitle' align="left">
                            Connect Account
                        </FormTitleTypography>
                    </Grid>
                    <Grid item xs={6} alignContent="center">
                        <Grid container direction={'row'} justifyContent={'flex-start'}>
                            <SearchTitleTypography align="left">
                                Search for your financial institution to connect your accounts
                            </SearchTitleTypography>
                            <SearchBarInput
                                id="inputSearch"
                                size="small"
                                placeholder="Search"
                                onChange={ (evt) => { handleOnSearchChange(evt.target.value); } }
                                value={searchText}
                                InputProps={{
                                    startAdornment: (
                                        <SearchInputAdornment position="start"></SearchInputAdornment>
                                    ),
                                    readOnly: false,
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6} alignContent="flex-end" paddingBottom={2}>
                        <Grid container direction={'row'} justifyContent={'flex-end'}>
                            <Typography style={{ fontStyle: 'italic' }}>
                                Import start date
                            </Typography>
                            <InfoTooltip id={'start_date_tooltip'}>
                                <Typography>
                                    <strong> Date Range section: </strong>
                                    Ark will pull transactions from selected accounts from the
                                    date selected through today. It is recommended that only
                                    transactions without existing journal entries are pulled
                                    into Ark. Some bank limitations may apply.
                                </Typography>
                            </InfoTooltip>
                            <DatePicker
                                label='Date'
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        id="filter_date"
                                        helperText={isValidImportDate}
                                    />
                                )}
                                onChange={setSelectedDate}
                                value={selectedDate}
                            />
                        </Grid>
                    </Grid>
                </HeaderGrid>
                <ScrollingStyledContainer>
                {
                    filteredBankInstitutions?.map(bi => {
                        const backgroundColor = selectedBankInstitution === bi.id ? '#dfecf2' : '';

                        return (
                            <BankInstitutionPaper
                                key={`BankInstitutionID_${bi.id}`}
                                style={{ backgroundColor }}
                                onClick={() => { handleSelectionModel(bi.id); }}
                            >
                                <Grid container alignItems="center">
                                    <Grid item xs={1} alignItems="center">
                                        <ImageBox >
                                        {
                                            bi.bankLogo && 
                                                <img src={`data:image/png;base64,${bi.bankLogo}`} alt="" width={32} height={32} /> 
                                        }
                                        </ImageBox>
                                    </Grid>
                                    <Grid item xs={11} alignItems="center">
                                        <Grid container direction={'row'} justifyContent={'flex-start'}>
                                            <SearchTitleTypography variant='label' align="left">
                                                {bi.bankName}
                                            </SearchTitleTypography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </BankInstitutionPaper>
                        );
                    })
                }
                </ScrollingStyledContainer>
                <ButtonBox direction="row" spacing={4} sx={{ mt: 3 }}>
                    <Button id="btn_cancel" variant="outlined" onClick={onCancel}>Cancel</Button>
                    <Button id="btn_ok" variant="contained" disabled={!isValidForm} onClick={handleSave}>Continue</Button>                    
                </ButtonBox>
            </MainStyledContainer>
        );
    }

    return (
        <FullScreenModal
            id="modal_allocation_workbook_info"
            open={true}
            title=""
            subtitle={getModelBodyJsx()}
        />
    );
};